import React from 'react';
import { motion } from 'framer-motion';

const supportList = [
  {
    title: '电子邮件',
    description: 'support@aiabc.me',
    features: ['仅工作日', '09:00 ~ 18:00', '3个工作日响应'],
    icon: 'fa-laptop-code'
  },
  {
    title: '紧急联系',
    description: '134-1746-2991',
    features: ['全年', '08:00 ~ 20:00', '仅处理重要紧急问题'],
    icon: 'fa-mobile-alt'
  },
  {
    title: '技术研发',
    description: 'dev@aiabc.me',
    features: ['仅工作日', '09:00 ~ 18:00', '7个工作日响应'],
    icon: 'fa-pencil-ruler'
  }
];

const Support = () => {
  return (
    <section id="support" className="py-20 bg-white dark:bg-gray-900 ">
      <div className="container">
        <motion.div
          className="section-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-primary dark:text-white mb-4">技术支持</h2>
          <p className="text-base md:text-lg text-gray-700 dark:text-gray-300 max-w-2xl mx-auto">如果您需要获得账号(含删除)相关、学习、教学问题等帮助，请与我们取得联系</p>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-3 gap-8">
          {supportList.map((service, index) => (
            <motion.div
              key={index}
              className="bg-white dark:bg-gray-700 rounded-lg shadow-lg overflow-hidden border border-gray-100 dark:border-gray-600"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
            >
              <div className="bg-secondary p-6 flex justify-between items-center">
                <h3 className="text-xl font-bold text-white">{service.title}</h3>
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
                  <i className={`fas ${service.icon} text-white`}></i>
                </div>
              </div>

              <div className="p-6">
                <p className="text-gray-600 dark:text-gray-300 mb-6">{service.description}</p>
                <ul className="space-y-2">
                  {service.features.map((feature, i) => (
                    <li key={i} className="flex items-center">
                      <i className="fas fa-check text-secondary mr-2"></i>
                      <span className="dark:text-gray-300">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Support;
